import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { AuthProvider } from 'react-oidc-context'
import store from './store';
import { WebStorageStateStore } from 'oidc-client-ts';


const oidcConfig = {
  authority: "https://sso.komoks.ru/realms/komoks",
  client_id: "s.komoks.ru",
  redirect_uri: 'https://s.komoks.ru',
  // redirect_uri: 'http://localhost:3000',
  // redirect_uri: 'https://192.168.0.150:3000',
  post_logout_redirect_uri: 'https://s.komoks.ru',
  // post_logout_redirect_uri: 'http://localhost:3000',
  response_type: "code",
  scope: "openid profile email roles offline_access",

  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew.html',
  accessTokenExpiringNotificationTime: 300,
  revokeAccessTokenOnSignout: true,
  includeIdTokenInSilentRenew: true,
  
  metadata: {
    authorization_endpoint: "https://sso.komoks.ru/realms/komoks/protocol/openid-connect/auth",
    issuer: "https://sso.komoks.ru/realms/komoks",
    userinfo_endpoint: "https://sso.komoks.ru/realms/komoks/protocol/openid-connect/userinfo",
    end_session_endpoint: "https://sso.komoks.ru/realms/komoks/protocol/openid-connect/logout",
    token_endpoint: "https://sso.komoks.ru/realms/komoks/protocol/openid-connect/token",
    revocation_endpoint:"https://sso.komoks.ru/realms/komoks/protocol/openid-connect/revoke"
  },
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  
  loadUserInfo: true,
  monitorSession: true,
  checkSessionInterval: 2000,
  
  silentRequestTimeout: 10000,
  
  onSigninCallback: () => {
    console.log('✅ Успешная авторизация');
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  
  onSignoutCallback: () => {
    console.log('👋 Выход из системы');
  },
  
  onUserLoaded: (user) => {
    console.log('👤 Пользователь загружен:', user.profile?.preferred_username);
  },
  
  onUserUnloaded: () => {
    console.log('👤 Пользователь выгружен');
  },
  
  onAccessTokenExpiring: () => {
    console.log('⏰ Токен доступа скоро истечет, начинаем обновление...');
  },
  
  onAccessTokenExpired: () => {
    console.log('⏰ Токен доступа истек');
  },
  
  onSilentRenewError: (error) => {
    console.error('❌ Ошибка при silent renew:', error);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <AuthProvider 
    {...oidcConfig} 
   
  >
    <Provider store={store}>
      <App />
    </Provider>
  </AuthProvider>

  // </React.StrictMode>
);

